import Component from '../core/Component'
import throttle from 'lodash/throttle'

export default class SectionLocationList extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            images: [],
            links: [],
            imageShow: null
        }

        this.index = 0
        this.throttledCleanup = throttle(this.cleanup, 500)
        this.animIndex = 0
    }

    prepare() {
        this.ref.links.forEach(linkEl => linkEl.addEventListener('mouseenter', this.handleLinkMouseEnter))
    }

    handleLinkMouseEnter = event => {
        const index = this.ref.links.findIndex(linkEl => linkEl === event.currentTarget)
        this.select(index)
    }

    select(index) {
        if (this.index === index) {
            return
        }
        const imageEl = this.ref.images[index]
        if (imageEl) {
            const clone = imageEl.cloneNode()
            this.animIndex = this.animIndex > 0 ? 0 : this.animIndex + 1
            const animations = ['enter1', 'enter2']
            clone.dataset.animation = animations[this.animIndex]
            this.ref.imageShow.appendChild(clone)
            this.throttledCleanup()
        }
        this.index = index
    }

    cleanup() {
        const bufferSize = 8
        const children = [...this.ref.imageShow.children]
        if (children.length > bufferSize) {
            for (let index = 0; index < children.length-bufferSize; index++) {
                const child = children[index]
                child.parentNode.removeChild(child)
            }
        }
    }
}